module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-1-APRILEOK-3275615e61bee45073302dff3fc21363.jpg";